import React, { useMemo, useCallback, useEffect, useRef } from 'react';
import {
  CForm,
  CFormLabel,
  CFormInput,
  CRow,
  CCol,
  CButton,
  CFormTextarea,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react';
import { useLoaderData, useNavigate, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AxiosInstance from 'src/components/Axios';
import { useConvertToLocalTime } from 'src/components/store/useConvertToLocalTime';
import PermissionsNoPage, { Permissions } from 'src/components/Permissions';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';

dayjs.extend(utc);
dayjs.extend(timezone);

const urlApi = '/notifications';

export async function LoaderUsersNotificationsVew({ params }) {
  if (!params?.pid) {
    return false;
  }

  const res = await AxiosInstance.get(`${urlApi}/${params.pid}`).then((response) => response);
  return res;
}

const UsersNotificationsVew = ({ user_data }) => {
  // if (!Permissions(user_data, 'Notifications', 'EDIT_NOTIFICATIONS')) {
  //   return <PermissionsNoPage />;
  // }

  const { data } = useLoaderData();
  const navigate = useNavigate();
  const location = useLocation();
  const toastShownRef = useRef(false);

  useEffect(() => {
    const toastState = location.state?.toast;
    if (toastState && !toastShownRef.current) {
      toastShownRef.current = true;
      const { type = 'success', message } = toastState;
      toast[type](message);
    }
  }, [location]);

  const formatValue = useCallback((value) => {
    if (value === null || value === undefined) return '';
    if (typeof value === 'boolean') return value ? 'Так' : 'Ні';
    return String(value);
  }, []);

  const formatDate = useCallback((value) => {
    if (!value) return '—';
    const parsed = dayjs(value);
    if (!parsed.isValid()) return '—';
    return parsed.format('DD.MM.YYYY HH:mm:ss');
  }, []);

  const fields = useMemo(() => {
    if (!data) return [];

    const result = [
      { key: 'id', label: 'ID', value: formatValue(data.id) },
      { key: 'username', label: 'Username', value: formatValue(data.users?.username) },
      { key: 'firstName', label: "Ім'я", value: formatValue(data.users?.firstName) },
      { key: 'title', label: 'Заголовок', value: formatValue(data.title) },
      { key: 'body', label: 'Текст повідомлення', value: formatValue(data.body), multiline: true },
      { key: 'type', label: 'Тип', value: formatValue(data.type) },
      // { key: 'dateEntered', label: 'Дата створення', value: data.dateEntered ? useConvertToLocalTime(data.dateEntered) : '' },
      { key: 'dateEntered', label: 'Дата створення', value: formatDate(data.dateEntered) },
      { key: 'status', label: 'Статус', value: formatValue(data.status) },
    ];

    if (data.error) {
      result.splice(5, 0, { key: 'error', label: 'Помилка', value: formatValue(data.error), multiline: true });
    }

    if (data.dateSend) {
      result.push({
        key: 'dateSend',
        label: 'Дата відправки',
        value: formatDate(data.dateSend),
      });
    }

    return result;
  }, [data, formatValue, formatDate]);

  const validNotificationTokens = useMemo(() => {
    if (!Array.isArray(data?.notificationTokens)) return [];
    return data.notificationTokens.filter(
      (tokenItem) =>
        tokenItem &&
        tokenItem.token &&
        typeof tokenItem.token === 'object' &&
        !Array.isArray(tokenItem.token) &&
        tokenItem.token.device_id,
    );
  }, [data]);

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  if (!data) {
    return (
      <CForm className="mb-3">
        <p className="text-medium-emphasis mb-3">Дані сповіщення відсутні.</p>
        <CButton color="secondary" variant="outline" onClick={handleBack}>
          Повернутись
        </CButton>
      </CForm>
    );
  }

  return (
    <CForm className="mb-3">
      <ToastContainer />
      <CRow className="g-3">
        {fields.map(({ key, label, value, multiline }) => (
          <CCol md={multiline ? 12 : 6} key={key}>
            <CFormLabel>{label}</CFormLabel>
            {multiline ? (
              <CFormTextarea value={value} disabled readOnly rows={6} />
            ) : (
              <CFormInput type="text" value={value} disabled readOnly autoComplete="off" />
            )}
          </CCol>
        ))}
      </CRow>
      {validNotificationTokens.length > 0 && (
        <div className="mt-4">
          <CFormLabel>Інформація по пристроям</CFormLabel>
          <CAccordion>
            {validNotificationTokens.map((tokenItem, index) => (
              <CAccordionItem itemKey={index} key={tokenItem?.id ?? index}>
                <CAccordionHeader>
                  {formatValue(tokenItem?.token?.device_id) || '—'}
                </CAccordionHeader>
                <CAccordionBody>
                  <CRow className="g-3">
                    <CCol md={4}>
                      <CFormLabel>Статус</CFormLabel>
                      <CFormInput type="text" value={formatValue(tokenItem?.status)} disabled readOnly />
                    </CCol>
                    <CCol md={4}>
                      <CFormLabel>Дата отримання</CFormLabel>
                      <CFormInput type="text" value={formatDate(tokenItem?.firebaseStatusRecived)} disabled readOnly />
                    </CCol>
                    <CCol md={4}>
                      <CFormLabel>Дата прочитання</CFormLabel>
                      <CFormInput type="text" value={formatDate(tokenItem?.fireBaseStatusRead)} disabled readOnly />
                    </CCol>
                  </CRow>
                </CAccordionBody>
              </CAccordionItem>
            ))}
          </CAccordion>
        </div>
      )}
      <div className="d-flex justify-content-start mt-4">
        <CButton color="secondary" variant="outline" onClick={handleBack}>
          Повернутись
        </CButton>
      </div>
    </CForm>
  );
};

export default UsersNotificationsVew;